import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import {
    Button,
    darken,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import {
    manufacturerColor,
    manufacturerHoverColor,
} from 'pages/ProjectsPage/colorVars'
import React from 'react'
import {
    ADD_MS_AND_MFR_TEXT,
    ADD_MS_ONLY_TEXT,
    ADD_PRODUCT_TEXT,
    CANCEL_TEXT,
    MS_MFR_INSTRUCTION_SUB_TEXT,
    MS_MFR_INSTRUCTION_TEXT,
    MSONLY_INSTRUCTION_TEXT,
    SELECT_TEXT,
} from '../constants'

interface AddProductSelectionDialogProps {
    open: boolean
    onMSOnlyClick: () => void
    onMSandMFRClick: () => void
    onCancel: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            width: pxToRem(605),
            height: pxToRem(505),
            minWidth: pxToRem(610),
            color: theme.palette.common.black,
        },
    },
    title: {
        paddingBottom: theme.spacing(0.5),
        '& .MuiTypography-h6': {
            color: '#304959',
            fontSize: pxToRem(34),
        },
    },
    contentContainer: {
        borderRadius: 10,
        backgroundColor: '#F2F2F2',
        width: pxToRem(560),
        height: pxToRem(126),
        padding: theme.spacing(2),
    },
    msOnlyContainer: {
        height: pxToRem(126),
        marginBottom: theme.spacing(1),
    },
    msAndnonMScontainer: {
        height: pxToRem(219),
    },
    contentSecondaryTitle: {
        color: '#304959',
        fontSize: pxToRem(18),
        fontWeight: 500,
        marginBottom: theme.spacing(0.5),
    },
    instructionText: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: pxToRem(14),
        fontWeight: 400,
        lineHeight: pxToRem(18),
    },
    instructionText2: {
        margin: theme.spacing(2, 2, 0, 4),
    },
    button: {
        borderRadius: pxToRem(100),
        fontSize: pxToRem(14),
        width: pxToRem(95),
        height: pxToRem(32),
    },
    msOnlyButton: {
        backgroundColor: '#F38936',
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: darken('#F78909', 0.05),
        },
    },
    msMfrButton: {
        backgroundColor: manufacturerColor,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: manufacturerHoverColor,
        },
    },
    cancelButton: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #C9C9C9',
    },
    buttonContainer: {
        marginTop: theme.spacing(1),
        float: 'right',
    },
    actionContainer: {
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(2.5),
    },
}))

export const AddProductSelectionDialog = ({
    open,
    onMSOnlyClick,
    onMSandMFRClick,
    onCancel,
}: AddProductSelectionDialogProps) => {
    const classes = useStyles()
    return (
        <Dialog
            open={open}
            data-testid="addProductSelection"
            maxWidth="lg"
            className={classes.dialog}
        >
            <DialogTitle className={classes.title}>
                {ADD_PRODUCT_TEXT}
            </DialogTitle>
            <DialogContent>
                <div
                    className={clsx([
                        classes.contentContainer,
                        classes.msOnlyContainer,
                    ])}
                >
                    <Typography
                        className={classes.contentSecondaryTitle}
                        component="div"
                    >
                        {ADD_MS_ONLY_TEXT}
                    </Typography>
                    <Typography
                        className={classes.instructionText}
                        component="div"
                    >
                        {MSONLY_INSTRUCTION_TEXT}
                    </Typography>
                    <div className={classes.buttonContainer}>
                        <Button
                            data-testid="btnSelectMS"
                            disableRipple
                            className={clsx([
                                classes.button,
                                classes.msOnlyButton,
                            ])}
                            onClick={onMSOnlyClick}
                        >
                            {SELECT_TEXT}
                        </Button>
                    </div>
                </div>
                <div
                    className={clsx([
                        classes.contentContainer,
                        classes.msAndnonMScontainer,
                    ])}
                >
                    <Typography
                        className={classes.contentSecondaryTitle}
                        component="div"
                    >
                        {ADD_MS_AND_MFR_TEXT}
                    </Typography>
                    <Typography
                        className={classes.instructionText}
                        component="div"
                    >
                        {MS_MFR_INSTRUCTION_TEXT}
                    </Typography>
                    <Typography
                        className={clsx([
                            classes.instructionText,
                            classes.instructionText2,
                        ])}
                        component="div"
                    >
                        {MS_MFR_INSTRUCTION_SUB_TEXT}
                    </Typography>
                    <div className={classes.buttonContainer}>
                        <Button
                            data-testid="btnSelectMSandMFR"
                            disableRipple
                            className={clsx([
                                classes.button,
                                classes.msMfrButton,
                            ])}
                            onClick={onMSandMFRClick}
                        >
                            {SELECT_TEXT}
                        </Button>
                    </div>
                </div>
            </DialogContent>
            <DialogActions className={classes.actionContainer}>
                <Button
                    data-testid="btnCancel"
                    disableRipple
                    className={clsx([classes.button, classes.cancelButton])}
                    onClick={onCancel}
                >
                    {CANCEL_TEXT}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddProductSelectionDialog
